import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerOne from "../components/DashBoardLayerOne";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getFarmerData } from "../lib/api";


const HomePageOne = () => {
  const [startDate, setStartDate] = useState(new Date(new Date().setMonth(new Date().getMonth() - 1))); // Default: 1 month ago
  const [endDate, setEndDate] = useState(new Date()); // Default: today
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const token = localStorage.getItem('token');
      const fromDate = formatDate(startDate);
      const toDate = formatDate(endDate);
      
      const data = await getFarmerData(token, fromDate, toDate);
      
      setApiData(data.data);
    } catch (err) {
      setError(err.message);
      console.error("Failed to fetch dashboard data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDateSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };


  const customDatePickerStyles = {
    datePickerWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      padding: '12px 16px',
    },
    dateInput: {
      backgroundColor: 'white',
      border: '1px solid #ced4da',
      borderRadius: '4px',
      padding: '6px 12px',
      fontSize: '14px',
      width: '120px',
      textAlign: 'center',
      cursor: 'pointer',
    },
    label: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#495057',
      margin: '0',
      whiteSpace: 'nowrap',
    },
    button: {
      backgroundColor: '#1B5E20',
      color: 'white',
      border: 'none',
      padding: '8px 16px',
      borderRadius: '4px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      transition: 'background-color 0.2s',
    },
  };

  return (
    <>
      {/* <MasterLayout> */}
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
          <Breadcrumb title="Dashboard" />
          
          <div>
            <Form onSubmit={handleDateSubmit} className="d-flex align-items-center">
              <div style={customDatePickerStyles.datePickerWrapper}>
                <p style={customDatePickerStyles.label}>Select Date</p>
                
                <div className="d-flex align-items-center gap-2">
                  <Icon icon="uil:calender" width="18" className="text-muted" />
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    maxDate={endDate}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    style={customDatePickerStyles.dateInput}
                    wrapperClassName="date-picker"
                  />
                  <span className="text-muted">To</span>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    maxDate={new Date()}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    style={customDatePickerStyles.dateInput}
                    wrapperClassName="date-picker"
                  />
                </div>
              </div>
              
              <button 
                type="submit" 
                style={customDatePickerStyles.button}
                onMouseOver={(e) => e.target.style.backgroundColor = '#145214'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#1B5E20'}
              >
                Apply
              </button>
            </Form>
          </div>
        </div>

        {/* Display loading or error states */}
        {loading && (
          <div className="text-center p-5">
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-muted">Loading dashboard data...</p>
          </div>
        )}

        {error && (
          <div className="alert alert-danger" role="alert">
            <Icon icon="mdi:alert-circle" width="20" className="me-2" />
            Error loading dashboard data: {error}
            <button 
              className="btn btn-sm btn-outline-danger ms-3"
              onClick={fetchData}
            >
              Retry
            </button>
          </div>
        )}

        {/* Display Dashboard when data is loaded */}
        {!loading && !error && apiData && (
          <DashBoardLayerOne farmerData={apiData} />
        )}
      {/* </MasterLayout> */}
    </>
  );
};

export default HomePageOne;